import { ToastOptions, toast } from 'react-toastify'
import SuccessBanner from 'common/Banners/SuccessBanner'
import ErrorBanner from 'common/Banners/ErrorBanner'

type CustomToastHook = {
  showSuccess: (message: string, options?: ToastOptions) => void
  showError: (
    message: string | React.ReactNode,
    options?: ToastOptions,
    showWarningIcon?: boolean
  ) => void
}

// CustomWrapper
const useToast = (isRedesign = false): CustomToastHook => {
  const showSuccess = (message: string, options?: ToastOptions) => {
    toast(<SuccessBanner message={message} isRedesign={isRedesign} />, {
      position: 'bottom-left',
      hideProgressBar: true,
      closeButton: false,
      ...options,
    })
  }

  const showError = (
    message: string | React.ReactNode,
    options?: ToastOptions,
    showWarningIcon?: boolean
  ) => {
    toast(
      <ErrorBanner
        message={message}
        isRedesign={isRedesign}
        showWarningIcon={showWarningIcon}
      />,
      {
        position: 'bottom-left',
        hideProgressBar: true,
        closeButton: false,
        autoClose: false,
        ...options,
      }
    )
  }

  return {
    showError,
    showSuccess,
  }
}

export default useToast
